var map = {
	"./BarCode.svg": 14733,
	"./EllipseIcon.svg": 7060,
	"./H.svg": 74285,
	"./HLine.svg": 68407,
	"./ImageIcon.svg": 65517,
	"./QrCode.svg": 9613,
	"./RectIcon.svg": 27002,
	"./TableIcon.svg": 15138,
	"./TextIcon.svg": 18049,
	"./TextLong.svg": 92224,
	"./VLine.svg": 18873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94086;